/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ProtocolType;
(function (ProtocolType) {
    ProtocolType["DeliverCustomer"] = "DeliverCustomer";
    ProtocolType["ReturnCustomer"] = "ReturnCustomer";
    ProtocolType["DeliverService"] = "DeliverService";
    ProtocolType["ReturnService"] = "ReturnService";
})(ProtocolType || (ProtocolType = {}));
export function ProtocolTypeFromJSON(json) {
    return ProtocolTypeFromJSONTyped(json, false);
}
export function ProtocolTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ProtocolTypeToJSON(value) {
    return value;
}
